jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});

setInterval(function() {
    var chatWidget = document.querySelector("iframe[title='chat widget']");
    if (chatWidget) {
        chatWidget.style.position = "fixed";
        chatWidget.style.bottom = "150px";
    }
}, 500);

